<section>
    <div class="content">

        <h1>{{ text.header }}</h1>

        <h2 id="m716">{{ text.preambleTitle }}</h2>
        <p>{{ text.preambleParagraph1 }}</p>
        <p>{{ text.preambleParagraph2 }}</p>
        <p>{{ text.versionDate }}</p>

        <h2 id="m3">{{ text.controllerTitle }}</h2>
        <p style="white-space: pre-line">{{ text.controllerAddress }}</p>
        <p>
            E-Mail: <a [href]="'mailto:' + text.controllerEmail">{{ text.controllerEmail }}</a>
        </p>

        <h2 id="mOverview">{{ text.overviewTitle }}</h2>
        <p>{{ text.overviewIntro }}</p>

        <h3>{{ text.overviewDataHeading }}</h3>
        <ul>
            <li>{{ text.dataType1 }}.</li>
            <li>{{ text.dataType2 }}.</li>
            <li>{{ text.dataType3 }}.</li>
            <li>{{ text.dataType4 }}.</li>
            <li>{{ text.dataType5 }}.</li>
            <li>{{ text.dataType6 }}.</li>
        </ul>
        <h3>{{ text.overviewSubjectsHeading }}</h3>
        <ul>
            <li>{{ text.subject1 }}.</li>
            <li>{{ text.subject2 }}.</li>
        </ul>

        <h3>{{ text.overviewPurposesHeading }}</h3>
        <ul>
            <li>{{ text.purpose1 }}.</li>
            <li>{{ text.purpose2 }}.</li>
            <li>{{ text.purpose3 }}.</li>
            <li>{{ text.purpose4 }}.</li>
            <li>{{ text.purpose5 }}.</li>
            <li>{{ text.purpose6 }}.</li>
        </ul>




        <h2 id="m2427">{{ text.legalBasisTitle }}</h2>
        <p><strong>{{ text.legalBasisTitle }} (GDPR):</strong> {{ text.legalBasisIntro }}</p>
        <ul>
            <li><strong>{{ text.legalItem1 }}</strong></li>
            <li><strong>{{ text.legalItem2 }}</strong></li>
        </ul>
        <p><strong>Nationale Datenschutzregelungen:</strong> {{ text.nationalLawNote }}</p>
        <p><strong>Hinweis zu DSGVO und Schweizer DSG:</strong> {{ text.swissNote }}</p>




        <h2 id="m27">{{ text.securityTitle }}</h2>
        <p>{{ text.securityParagraph1 }}</p>
        <p>{{ text.securityParagraph2 }}</p>
        <p>{{ text.securityParagraph3 }}</p>




        <h2>{{ text.storageTitle }}</h2>
        <p>{{ text.storageParagraph1 }}</p>
        <p>{{ text.storageParagraph2 }}</p>
        <p>{{ text.storageParagraph3 }}</p>
        <p>{{ text.storageParagraph4 }}</p>
        <p>{{ text.storageParagraph5 }}</p>
        <ul>
            <li>{{ text.storageItem1 }}</li>
            <li>{{ text.storageItem2 }}</li>
            <li>{{ text.storageItem3 }}</li>
            <li>{{ text.storageItem4 }}</li>
        </ul>





        <h2 id="m10">{{ text.rightsTitle }}</h2>
        <p>{{ text.rightsIntro }}</p>
        <ul>
            <li><strong>{{ text.right1 }}</strong></li>
            <li><strong>{{ text.right2 }}</strong></li>
            <li><strong>{{ text.right3 }}</strong></li>
            <li><strong>{{ text.right4 }}</strong></li>
            <li><strong>{{ text.right5 }}</strong></li>
            <li><strong>{{ text.right6 }}</strong></li>
            <li><strong>{{ text.right7 }}</strong></li>
        </ul>






        <h2 id="m225">{{ text.hostingTitle }}</h2>
        <p>{{ text.hostingIntro }}</p>

        <ul class="m-elements">
            <li><strong>{{ text.hostingDataTypes }}</strong></li>
            <li><strong>{{ text.hostingSubjects }}</strong></li>
            <li><strong>{{ text.hostingPurposes }}</strong></li>
            <li><strong>{{ text.hostingRetention }}</strong></li>
            <li><strong>{{ text.hostingLegal }}</strong></li>
        </ul>

        <p><strong>{{ text.hostingNoteTitle }}</strong></p>
        <ul class="m-elements">
            <li><strong>{{ text.hostingAccessLogs }}</strong></li>
            <li><strong>{{ text.hostingStrato }}</strong></li>
        </ul>




        <h2 id="m182">{{ text.contactTitle }}</h2>
        <p>{{ text.contactIntro }}</p>

        <ul class="m-elements">
            <li><strong>{{ text.contactDataTypes }}</strong></li>
            <li><strong>{{ text.contactSubjects }}</strong></li>
            <li><strong>{{ text.contactPurposes }}</strong></li>
            <li><strong>{{ text.contactRetention }}</strong></li>
            <li><strong>{{ text.contactLegal }}</strong></li>
        </ul>

        <p><strong>{{ text.contactNoteTitle }}</strong></p>
        <ul class="m-elements">
            <li><strong>{{ text.contactFormInfo }}</strong></li>
        </ul>


    </div>
</section>